<div class="select" (mouseover)="enter()" (mouseleave)="leave()" [class.mod-large]="large">
  <label *ngIf="label">
    {{label | translate}}
  </label>
  <div class="select-container" [class.mod-error]="validate && !isValid">
    <div *ngIf="!isOpen && !!emptyPlaceholder && data?.length === 0 && selection.length === 0; else multipleTemplate" class="empty-placeholder">
      <div class="single mod-empty">
        <div class="value mod-placeholder">
          {{emptyPlaceholder | translate}}
        </div>
      </div>
    </div>

    <ng-template #multipleTemplate>
      <div *ngIf="multiple; else single" class="multiple">
        <div *ngFor="let item of selection; trackBy:identify" class="option">
          {{item.label}}
          <a class="option-deselect" (click)="remove(item)">✖</a>
        </div>
        <input #mainInput type="text" autocomplete="off" class="filter-multiple" (focus)="showDropdown()" (click)="showDropdown()" (blur)="hideDropdown(true)"
          [(ngModel)]="filter" [attr.placeholder]="hasSelection ? null : (placeholder | translate)" />
      </div>
    </ng-template>

    <ng-template #single>
      <div *ngIf="!isOpen; else dropdownFilter" class="single" (click)="showDropdown()">
        <div *ngIf="hasSelection; else placeholderTemplate" class="value">
          <span class="ellipsize">{{selection[0].label}}</span>
          <a *ngIf="clearable" class="option-deselect" (click)="$event.stopPropagation(); remove(selection[0])">✖</a>
        </div>
        <ng-template #placeholderTemplate>
          <div *ngIf="placeholder != null" class="value mod-placeholder">
            {{placeholder | translate}}
          </div>
        </ng-template>
        <div class="caret icon-caret"></div>
      </div>

      <ng-template #dropdownFilter>
        <input #mainInput cpAutofocus type="text" autocomplete="off" class="filter-single" (blur)="hideDropdown(true)" [(ngModel)]="filter" />
      </ng-template>
    </ng-template>
  </div>
  <ul *ngIf="isOpen && data.length !== 0" class="dropdown">
    <li *ngFor="let item of data; index as index; trackBy: identify" class="dropdown-item" [class.mod-focus]="focusedIndex === index"
      [cpFocusIndex]="index" [currentIndex]="focusedIndex" (mousedown)="preventFocusLoss($event)" (mouseenter)="focusIndex(index)">
      <a (click)="select(item)" class="select-dropdown-item" [class.mod-selected]="isSelected(item)" [class.branding-accent-normal-background]="isSelected(item)">
        <span class="ellipsize">{{item.label}}</span>
      </a>
    </li>
  </ul>
  <input #hiddenInput type="hidden" [id]="inputId" [formControl]="cpFormControl" [ngModel]="stringValue" />
  <cp-validation-error *ngIf="showErrors" [errors]="cpFormControl" [validate]="validate">
  </cp-validation-error>
</div>
